import React from 'react';
import { Spin } from 'antd';

const PageLoading = () => {
	<div className='page-loader'>
		<Spin />
	</div>;
};

export default PageLoading;
